// extracted by mini-css-extract-plugin
module.exports = {"searchbox":"DiningDetails_searchbox__Gd3bS","hr":"DiningDetails_hr__2egiR","anchor":"DiningDetails_anchor__3tx93"};